import { render, staticRenderFns } from "./AdminOrdersTable.vue?vue&type=template&id=c0299af6"
import script from "./AdminOrdersTable.vue?vue&type=script&lang=js"
export * from "./AdminOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0299af6')) {
      api.createRecord('c0299af6', component.options)
    } else {
      api.reload('c0299af6', component.options)
    }
    module.hot.accept("./AdminOrdersTable.vue?vue&type=template&id=c0299af6", function () {
      api.rerender('c0299af6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminOrdersTable.vue"
export default component.exports